import { render, staticRenderFns } from "./TrackMetrics.vue?vue&type=template&id=5bc452a6&scoped=true&"
import script from "./TrackMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./TrackMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TrackMetrics.vue?vue&type=style&index=0&id=5bc452a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc452a6",
  null
  
)

export default component.exports